/*
 * @Author: wjw this.wujiwen@gmail.com
 * @Date: 2022-12-14 16:50:05
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-06-26 17:19:52
 * @FilePath: /manage_property/src/permission.js
 * @Description: 动态路由
 */

import router from './core/router.js';
import storeMenu from './config/storeMenu.js';
import storeAccount from './config/storeAccount.js';
import { ElMessage } from 'element-plus';
import NProgress from 'nprogress'; // progress 进度条
import 'nprogress/nprogress.css'; // progress 样式
// import { findByRoleIds } from '@/data/ApiRole';
import { getLoginPath, getStaticRoutes } from './utils/router.js';
import accountManager from './utils/account.js';

const whiteList = ['/login', '/cuserLogin', '/displayPage', '/404', '/home']; // 不需要验证token的白名单路由

NProgress.configure({ showSpinner: false }); // NProgress 配置

router.beforeEach(async (to, from, next) => {
  // 进度条开始
  NProgress.start();

  // 获取token用于判断是否未登录
  const hasToken = accountManager.getToken();
  const loginPath = getLoginPath();

  // 判断有没有token，没有直接重定向到登录页
  if (hasToken) {
    // 有token又是前往登录页则重定向到首页
    if (to.path === loginPath) {
      next({ path: '/' });
      NProgress.done();
    } else {
      const StoreMenu = storeMenu();
      const staticRoutes = getStaticRoutes();
      StoreMenu.generateRoutes([], staticRoutes);

      const userStore = storeAccount();

      try {
        // 判断有没有账号信息，没有的话重新获取账号与路由菜单，有的话直接放行
        if (!userStore.accountId) {
          // 刷新的时候获取用户信息
          userStore.setLoginType(accountManager.getLoginType());
          await userStore.GetUserInfo();

          // 判断有没有路由，有的话添加路由然后放行，没有的话直接重定向到首页或者404
          if (to.meta.public || whiteList.includes(to.path)) {
            // next();
            const redirectedFrom = to.redirectedFrom ? { ...to.redirectedFrom } : { ...to };
            next({ ...redirectedFrom, replace: true });
          } else {
            next();
          }
        } else {
          next();
        }
      } catch (error) {
        // 获取个人信息报错直接清理本地缓存的个人信息然后回登录页
        await userStore.reset();
        ElMessage.error(error || 'Has Error');
        next(`${loginPath}?redirect=${to.path}`);
        NProgress.done();
      }
    }
  } else {
    // 判断要去的页面是不是白名单，白名单页面直接放行，否则回登录页
    if (to.meta.public || whiteList.includes(to.path)) {
      next();
    } else {
      next(`${loginPath}?redirect=${to.path}`);
      // NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
